import React from 'react';
import {
    Box,
    Typography,
    Grid,
    Paper,
    Divider,
    Chip
} from '@mui/material';
import { useFormularioSecretariaMunicipalAgriculturaStore } from 'stores/forms/formularioAgricultura.store';



const converterChaveValor = {
    'lei_municipal': 'Lei Municipal',
    'decreto': 'Decreto',
    'portaria': 'Portaria',
    'resolucao': 'Resolução',
    'instrucao_normativa': 'Instrução Normativa',
    'outros': 'Outros'
}

const Step2View: React.FC = () => {
    const { formulario } = useFormularioSecretariaMunicipalAgriculturaStore();

    if (!formulario) {
        return (
            <Box display="flex" justifyContent="center" p={3}>
                <Typography>Carregando informações...</Typography>
            </Box>
        );
    }

    const InfoField: React.FC<{ label: string; value: any }> = ({ label, value }) => (
        <Box mb={2}>
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                {label}
            </Typography>
            <Typography variant="body1">
                {value || 'Não informado'}
            </Typography>
        </Box>
    );

    const BooleanField: React.FC<{ label: string; value: boolean | null }> = ({ label, value }) => (
        <Box mb={2}>
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                {label}
            </Typography>
            <Chip
                label={value === true ? 'Sim' : value === false ? 'Não' : 'Não informado'}
                color={value === true ? 'success' : value === false ? 'error' : 'default'}
                size="small"
            />
        </Box>
    );

    const formatCurrency = (value: number | null) => {
        if (!value) return 'Não informado';
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(value);
    };

    const formatDate = (dateString: string | null) => {
        if (!dateString) return 'Não informado';
        try {
            try {
                const date = new Date(dateString);
                if (isNaN(date.getTime())) return '';

                const day = date.getDate().toString().padStart(2, '0');
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const year = date.getFullYear();

                return `${day}/${month}/${year}`;
            } catch (error) {
                return '';
            }
        } catch {
            return dateString;
        }
    };

    return (
        <Paper elevation={1} sx={{ p: 3, mt: 2 }}>
            <Typography variant="h5" gutterBottom color="primary">
                Informações Complementares
            </Typography>

            <Divider sx={{ mb: 3 }} />

            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="h6" gutterBottom sx={{ color: '#1976d2', fontWeight: 'bold' }}>
                        Fundo Municipal de Agricultura Familiar
                    </Typography>
                </Grid>

                <Grid item xs={12} md={6}>
                    <BooleanField
                        label="Possui Fundo Municipal de Agricultura Familiar"
                        value={formulario.fundo_municipal_agricultura_familiar}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <InfoField
                        label="Tipo de Publicação"
                        value={converterChaveValor[formulario.tipo_publicacao as keyof typeof converterChaveValor] || 'Não informado'}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <InfoField
                        label="Número da Publicação"
                        value={formulario.nro_publicacao}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <InfoField
                        label="Data da Publicação"
                        value={formatDate(formulario.data_publicacao)}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Divider sx={{ my: 2 }} />
                    <Typography variant="h6" gutterBottom sx={{ color: '#1976d2', fontWeight: 'bold' }}>
                        Orçamento
                    </Typography>
                </Grid>

                <Grid item xs={12} md={6}>
                    <InfoField
                        label="Orçamento da Secretaria"
                        value={formatCurrency(formulario.orcamento_secretaria)}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <InfoField
                        label="Porcentagem do Orçamento no Ano Corrente (%)"
                        value={formulario.porcentagem_orcamento_ano_corrente ? `${formulario.porcentagem_orcamento_ano_corrente}%` : 'Não informado'}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Divider sx={{ my: 2 }} />
                    <Typography variant="h6" gutterBottom sx={{ color: '#1976d2', fontWeight: 'bold' }}>
                        Instrumento Legal para Manutenção Agrícola
                    </Typography>
                </Grid>

                <Grid item xs={12} md={6}>
                    <BooleanField
                        label="Possui Instrumento Legal para Manutenção Agrícola"
                        value={formulario.instrumento_legal_manutencao_agricola}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <InfoField
                        label="Tipo de Publicação do Instrumento Legal"
                        value={converterChaveValor[formulario.tipo_publicacao_instrumento_legal_manutencao_agricola as keyof typeof converterChaveValor] || 'Não informado'}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <InfoField
                        label="Número da Publicação do Instrumento Legal"
                        value={formulario.numero_publicacao_instrumento_legal_manutencao_agricola}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <InfoField
                        label="Data da Publicação do Instrumento Legal"
                        value={formatDate(formulario.data_publicacao_instrumento_legal_manutencao_agricola)}
                    />
                </Grid>
            </Grid>
        </Paper>
    );
};

export default Step2View; 